import { Fragment } from "react";
import { Container } from "reactstrap";
import PageImage from "../../CommonComponents/PageImage";
import BackgroundColor from "./BackgroundColor";
import Badge from "./Badge";
import ButtonBackground from "./ButtonBackground";
import Buttons from "./Buttons";
import DotButtonBadge from "./DotButtonBadge";
import ElementBadge from "./ElementBadge";
import Fonts from "./Fonts";
import FontsAndBadge from "./FontsAndBadge";
import Heading from "./Heading";
import Icons from "./Icons";
import Images from "./Images";
import LabelBadge from "./LabelBadge";
import MassageBox from "./MassageBox";
import ModalButtons from "./ModalButton/ModalButtons";
import SharedDocument from "./SharedDocument/SharedDocument";
import SidebarIcon from "./SidebarIcon/SidebarIcon";
import SpanAndParagraph from "./SpanAndParagraph";
import TemplateButtons from "./TemplateButtons/TemplateButtons";

const ElementsContainer = () => {
  return (
    <Fragment>
      <PageImage />
      <Container>
        <Heading />
        <SpanAndParagraph />
        <Images />
        <Fonts />
        <FontsAndBadge />
        <Badge />
        <LabelBadge />
        <ElementBadge />
        <DotButtonBadge />
        <BackgroundColor />
        <ButtonBackground />
        <Icons />
        <SidebarIcon />
        <TemplateButtons />
        <MassageBox />
        <SharedDocument />
        <Buttons />
        <ModalButtons />
      </Container>
    </Fragment>
  );
};

export default ElementsContainer;
